import type { PcmpPendingStage } from '../types/pcmpReports.types';

export const PCMP_PENDING_STAGE_LABELS = {
  MKT_PENDING: 'Marketing Pending',
  MIS_PENDING: 'MIS Pending',
  ACC_PENDING: 'Accounts Pending',
  MKTDISB_PENDING: 'Marketing Disbursement Pending',
  DISBURSED: 'Disbursed',
} as const satisfies Record<PcmpPendingStage, string>;

export const PCMP_PENDING_STAGE_OPTIONS = Object.entries(PCMP_PENDING_STAGE_LABELS).map(
  ([code, label]) => ({ code, label }),
);
